import React, { useState } from 'react';
import { FiTag, FiMessageCircle, FiCheckSquare, FiLink, FiExternalLink } from 'react-icons/fi';

// Importazione dei componenti (da creare)
import Categories from './sections/Categories';
import Questions from './sections/Questions';
import Answers from './sections/Answers';
import Associer from './sections/Associer';
import APP from './Chatbot';
import Log from './sections/Log';

const Dashboard: React.FC = () => {
  const [activeSection, setActiveSection] = useState('categories');
  const [loading, setLoading] = useState(false); // Stato per gestire il caricamento

  const menuItems = [
    { id: 'categories', label: 'Categorie', icon: <FiTag /> },
    { id: 'questions', label: 'Domande', icon: <FiMessageCircle /> },
    { id: 'answers', label: 'Risposte', icon: <FiCheckSquare /> },
    { id: 'associer', label: 'Associa', icon: <FiLink /> },
    // { id: 'problemes', label: 'Problemi frequenti', icon: <FiExternalLink /> }
  ];

  const handleMenuClick = (id: string) => {
    setActiveSection(id); // Cambia la sezione attiva al clic
  };

  const handleMenuDoubleClick = (id: string) => {
    setLoading(true); // Inizia il caricamento
    console.log(`Ricaricamento della sezione: ${id}`);

    // Simula un caricamento (sostituisci con la tua logica di caricamento reale)
    setTimeout(() => {
      setActiveSection(id); // Ricarica la sezione attiva
      setLoading(false); // Ferma il caricamento
    }, 100); // Ritardo di 1 secondo per simulare il caricamento
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed left-0 top-0 h-full w-64 bg-white border-r border-gray-200 p-4">
        <div className="mb-8">
          <h1 className="text-xl font-bold text-gray-800">Amministrazione</h1>
        </div>
        
        <nav className="space-y-1">
          {menuItems.map(item => (
            <button
              key={item.id}
              onClick={() => handleMenuClick(item.id)} // Usa il gestore di clic
              onDoubleClick={() => handleMenuDoubleClick(item.id)} // Usa il gestore di doppio clic
              className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors
                ${activeSection === item.id 
                  ? 'bg-indigo-50 text-indigo-600' 
                  : 'text-gray-600 hover:bg-gray-50'
                }`}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Contenuto principale */}
      <div className="ml-64 p-8">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="loader">Caricamento...</div> 
          </div>
        ) : (
          <>
            {activeSection === 'categories' && <Categories />}
            {activeSection === 'questions' && <Questions />}
            {activeSection === 'answers' && <Answers />}
            {activeSection === 'associer' && <Associer />}
            {/* {activeSection === 'problemes' &&  <Log />} */}
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
